import { createContext } from 'react';
import { SliderContent } from 'src/layout/MobileLayout';

export const MobileLayoutContext = createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handleNext: (content: SliderContent) => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handlePrev: () => {},
});
